// import pacchetti
import { Link, useNavigate } from "react-router-dom";

// import hooks
import { useAuthContext } from "../hooks/useAuthContext";

// styles & immagini
import Giuvi from "../assets/giuvi_G.png";
import MenuIcon from "../assets/menu_icon.svg";
import BackIcon from "../assets/back.svg";
import "./Navbar.css";

export default function Navbar() {
  const { user } = useAuthContext();
  const navigazione = useNavigate();

  const toggleSidebar = () => {
    window.dispatchEvent(new CustomEvent("toggle-sidebar"));
  };

  const handleBack = () => {
    navigazione(-1);
  };

  return (
    <div className="navbar">
      <div className="navbar-content">
        {user && (
          <div className="menu-icon-container">
            <div className="menu-icon" onClick={toggleSidebar}>
              <img src={MenuIcon} alt="Menu Icon" />
            </div>
          </div>
        )}
        <div className="logo-container">
          <div className="logo">
            <img src={Giuvi} alt="Giuvi Logo" />
            <span onClick={() => navigazione("/")}>GiuviProjects</span>
          </div>
        </div>
      </div>
      <div className="navbar-right">
        {user ? (
          <button
            type="button"
            className="navbar-back-button"
            onClick={handleBack}
          >
            <img src={BackIcon} alt="Indietro" />
          </button>
        ) : (
          <div className="auth-links">
            <Link to="/login" className="login">
              Accedi
            </Link>
          </div>
        )}
      </div>
      <div className="navbar-divider"></div>
    </div>
  );
}
